/* ================================================================
   LUSINE – GESTION BADGES V67 (FIX BADGES CUSTOM / TAXES PAYÉES)
   ================================================================= */

(function() {

    // --- 1. SÉCURITÉ : CHECK PAGE ---
    if (!document.body.classList.contains('template-product')) {
        return; 
    }

    // --- 2. FONCTION DE MISE À JOUR ---
    function updateProductPageBadge() {

        const mainContainer = document.querySelector('.product-section, .main-product');
        if (!mainContainer) return;

        const jsonScript = mainContainer.querySelector('.lusine-badge-data');
        if (!jsonScript) return;

        let badgeData;
        try {
            badgeData = JSON.parse(jsonScript.textContent);
        } catch (e) { return; }

        const idInput = mainContainer.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (!idInput) return;

        const variantId = idInput.value;

        // C. Appliquer la logique
        if (badgeData[variantId]) {
            const data = badgeData[variantId];
            const allHolders = mainContainer.querySelectorAll('.product-badges-holder');

            // On boucle sur tous les conteneurs de la page
            allHolders.forEach(holder => {
                // On ignore les recommandations et le mini-panier
                if (!holder.closest('.product-item') && !holder.closest('.cart-product-item')) {
                    
                    const saleBadge = holder.querySelector('.lusine-sale-badge');
                    const customBadge = holder.querySelector('.lusine-custom-badge'); // On cherche le badge "Taxes payées"
                    
                    let isSaleActive = (data.discount >= 5);

                    // 1. GESTION DU BADGE SOLDE (%)
                    if (saleBadge) {
                        if (isSaleActive) {
                            saleBadge.innerText = data.text;
                            saleBadge.style.setProperty('display', 'flex', 'important');
                            saleBadge.style.setProperty('visibility', 'visible', 'important');
                            saleBadge.style.setProperty('opacity', '1', 'important');
                        } else {
                            saleBadge.style.setProperty('display', 'none', 'important');
                        }
                    }

                    // 2. GESTION DU CONTENEUR GLOBAL
                    // S'il y a un solde OU s'il y a un badge "Taxes payées", on force l'affichage du conteneur
                    if (isSaleActive || customBadge) {
                        holder.style.setProperty('display', 'flex', 'important');
                        holder.classList.add('force-visible');
                    } else {
                        // S'il n'y a ni solde, ni badge custom, on cache le conteneur pour éviter un espace vide
                        holder.style.setProperty('display', 'none', 'important');
                    }
                }
            });
        }
    }

    // --- 3. DÉCLENCHEURS ---
    document.addEventListener("DOMContentLoaded", () => {
        setTimeout(updateProductPageBadge, 100);

        const mainContainer = document.querySelector('.product-section, .main-product');
        if (mainContainer) {
            const idInput = mainContainer.querySelector('form[action*="/cart/add"] input[name="id"]');
            if (idInput) {
                const observer = new MutationObserver(() => {
                    updateProductPageBadge();
                });
                observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
            }

            document.body.addEventListener('click', function(e) {
                if(e.target.closest('.product-variants') || e.target.closest('label')) {
                    setTimeout(updateProductPageBadge, 100);
                }
            });
        }
    });

})();